module.exports = __webpack_public_path__ + "img/dayu.f07e038e.png";